import moment from "moment";
import React from "react";
import { Message } from "semantic-ui-react";
import ChangeLifecycleButtons from "../ChangeLifecycleButtons";

interface Props {
  documentId: number
  files: server.dto.ESignFile[]
  documentType: server.dto.DocumentTypes
}

const fileSourceLabels: { [key in server.dto.ESignFileSources]: string } = {
  fromUpload: RESX.ESign.Uploaded,
  fromStorage: RESX.ESign.AddedFromStorage,
  fromTemplate: RESX.ESign.GeneratedFromTemplate,
  unknown: ""

};
const SendOutDocument = (props: Props) => {
  return <div className="flex-column gap">
    <div>
      {RESX.ESign.DocumentToBeSignedIsCombinedFrom}:
    </div>

    <div>
      {props.files.map((file) => {
        return <div key={file.eSignFileId} className="panel-bg-color padding-large margin-bottom-mini">
          <strong>{file.fullName}</strong>
          <div className="text-sublabel">
            {fileSourceLabels[file.fileSource]} {moment.utc(file.createdUtc).fromNow()}
          </div>
        </div>;
      })}
    </div>

    <Message color="red" className="margin-bottom">
      {RESX.ESign.SendOutWarning}
    </Message>

    <div className="grow1"></div>

    <ChangeLifecycleButtons
      documentType={props.documentType}
      documentId={props.documentId}
      right="pending"
    />
  </div>;
};

export default SendOutDocument;